// @file Converting seconds to time format
// E.g. if you input 71, output would be 01:11

import { hyphenatedCurrentLocale } from '@@/bits/current_locale'

const secondsToSemiColonedText = function (seconds: number, shouldRoundSeconds: boolean = false): string {
  const totalMinutes = Math.floor(seconds / 60)
  const leftoverSeconds = shouldRoundSeconds ? Math.round(seconds % 60) : seconds % 60
  const minutesText = totalMinutes < 10 ? '0' + totalMinutes : '' + totalMinutes
  const secondsText = leftoverSeconds < 10 ? '0' + leftoverSeconds : '' + leftoverSeconds
  return `${minutesText}:${secondsText}`
}

function getDateStringForDisplay(datetime: string | number | Date): string {
  const date = new Date(datetime)
  const formattedTime = date.toLocaleString(hyphenatedCurrentLocale, { hour: 'numeric', minute: 'numeric' })
  const formattedDate = date.toLocaleString(hyphenatedCurrentLocale, {
    year: 'numeric',
    day: 'numeric',
    month: 'long',
  })
  return `${formattedTime} • ${formattedDate}`
}

export { getDateStringForDisplay, secondsToSemiColonedText }
